import React from 'react';

export default () => [
    <h1 key="1">Page Coming Soon!</h1>,
    <h4 key="2">Look away I say!!!!!</h4>
];